import { DATE_FILTER_PRESET } from "components/DateFilterSelect/constants";

export const STATUS_VIEW = "status";
export const TYPE_VIEW = "type";

// view: which card breakdown is currently displayed ("status" or "type"). The center
// filter always shows the *complementary* dimension - Type options while viewing
// By-status cards, Status options while viewing By-type cards - since filtering a view
// by its own display dimension doesn't make sense. typeIds/statusIds are kept
// independently so switching tabs back and forth doesn't lose either selection.
export const DEFAULT_FILTERS = {
  noticeDate: null,
  typeIds: [],
  statusIds: [],
  managerEmails: [],
  view: STATUS_VIEW,
};

export const FILTER_STORAGE_KEY = "home.filters";

// Shared with useSessionFilters so the very first page load (Home/index.js, before
// DashboardSection mounts) and the live filter UI read the exact same persisted value.
export const readStoredFilters = (key, fallback = DEFAULT_FILTERS) => {
  try {
    const raw = window.sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

const isChooseDateRange = (noticeDate) =>
  noticeDate?.dateType === DATE_FILTER_PRESET.CHOOSE_DATE_RANGE;

// DateFilterRange is only populated for an explicit "Choose date range" selection -
// every other preset (or no selection) is resolved server-side from the preset id below.
const buildNoticeDateRange = (noticeDate) =>
  isChooseDateRange(noticeDate) && noticeDate.start && noticeDate.end
    ? { start: noticeDate.start, end: noticeDate.end }
    : null;

// Mirrors the Transaction list's dateFilterType dictionary convention: keyed by the
// same "notice date" label, valued by the DATE_FILTER_PRESET id.
const buildDateFilterType = (noticeDate) =>
  noticeDate?.dateType != null ? { "notice date": noticeDate.dateType } : {};

// By-status and By-type are treated as independent tabs: only the dimension currently
// editable via the center filter (see DashboardFilters' isStatusCenter) is sent - Type
// while viewing By-status cards, Status while viewing By-type cards. The other
// dimension's stored selection is kept in local/session state so it isn't lost if the
// user switches back, but it's excluded here so it never combines with the other tab's
// filter in the request.
const activeCenterFilters = (filters) => {
  const isStatusCenter = filters.view === TYPE_VIEW;
  return {
    typeIds: isStatusCenter ? [] : filters.typeIds,
    statusIds: isStatusCenter ? filters.statusIds : [],
  };
};

// Builds the POST body for GET_HOME_PAGE_DATA, matching the backend's request contract.
// Per Figma, a single shared filter row drives both the Pre-transaction and Transaction
// sections at once, so the same selections are sent for both halves of the request.
export const buildHomeFilterRequest = (clientId, filters) => {
  const center = activeCenterFilters(filters);
  const noticeDateRange = buildNoticeDateRange(filters.noticeDate);
  const dateFilterType = buildDateFilterType(filters.noticeDate);

  return {
    clientId,
    transactionNoticeDateFiler: noticeDateRange,
    preTransactionNoticeDateFiler: noticeDateRange,
    transactionManagerEmails: filters.managerEmails,
    preTransactionManagerEmails: filters.managerEmails,
    transactionStatusIds: center.statusIds,
    preTransactionStatusIds: center.statusIds,
    transactionTypeIds: center.typeIds,
    preTransactionTypeIds: center.typeIds,
    transactionDateFilterType: dateFilterType,
    preTransactionDateFilterType: dateFilterType,
  };
};
